
<p-panel header="CNP Employee Claims" class="m-3" aria-label="CNP Employee Claims" role="region">
    <p><strong>First Name: </strong> {{profile.displayName}}</p>
    <p><strong>Last Name: </strong> {{profile.surname}}</p>
    <p><strong>Email: </strong> {{profile.userPrincipalName}}</p>
    <p><strong>Id: </strong> {{profile.id}}</p>
    <p><strong>Display Name: </strong> {{profile.displayName}}</p>
    <p><strong>Job Title: </strong> {{profile.jobTitle}}</p>
    <p><strong>Office Location: </strong> {{profile.officeLocation}}</p>
</p-panel>

